<template>
  <v-pagination
    outlined
    style="background: #E5E5E5;"
    :color="$theme.primary"
    total-visible="7"
    v-model="get_fornecedors_filtros.page"
    :length="get_fornecedors.totalPages"
    @input="setPage($event)"
  ></v-pagination>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_fornecedors", "get_fornecedors_filtros"])
  },
  methods: {
    ...mapActions(["listar_fornecedors"]),
    setPage(page) {
      if (page) {
        console.log("page", page);
        this.get_fornecedors_filtros.page = page;
        this.listar_fornecedors();
      }
    }
  }
};
</script>
